import Modal from '@/utility/modal_triggers';
import Alert from '@/utility/alert_triggers';
import { isObject } from '@/utility/functions';

export default {
  data() {
    return {
      cartActionData: {
        items: [],
        message: null,
      },
      isAddCollatedSetLoading: false,
      isAddCartLoading: false,
      isAddSampleLoading: false,
      isAddSampleCardLoading: false,
      isCartModalOpen: false,
      showAmountMessage: false,
    };
  },

  methods: {
    addCollatedSetToCart(sku) {
      this.isAddCollatedSetLoading = true;

      let data = new FormData();
          data.append('sku[0]', sku);
          data.append('quantity[0]', 1);
          data.append('warehouse[0]', '03');

        this.addToCart(data)
          .finally(() => {

            this.isAddCollatedSetLoading = false;

          });
    },

    addSampleCardToCart(sku) {
      this.isAddSampleCardLoading = true;

      let data = new FormData();
          data.append('sku[0]', sku);
          data.append('quantity[0]', 1);
          data.append('warehouse[0]', '03');

        this.addToCart(data)
          .finally(() => {

            this.isAddSampleCardLoading = false;

          });
    },

    addSample(event) {
      this.isAddSampleLoading = true;

      let data = new FormData();
          data.append('sku[0]', document.querySelector('[name="sku[0]"]:checked').value);
          data.append('quantity[0]', document.querySelector('[name="memo_qty"]').value || 1);
          data.append('warehouse[0]', '03');

      this.addToCart(data)
        .finally(() => {

          this.isAddSampleLoading = false;

        });
    },

    async addToCart(data) {
      return await this.$http.post('/cart/add', data)
        .then(response => {
          Object.assign(this.cartActionData, {
            items: response.data.items,
            message: response.data.message,
          });

          this.isCartModalOpen = true;

          this.toggleActiveCartIcon();
        })
        .catch(this.errorModalResponse);
    },

    addYardageToCart(event) {
      let quantity = (document.querySelector('[name="yard_qty"]') || {}).value;

      if(!quantity) {
        this.flashAmountMessage();

        return;
      }

      this.isAddCartLoading = true;

      let data = new FormData();
          data.append('sku[0]', document.querySelector('[name="sku[0]"]:checked').value);
          data.append('quantity[0]', quantity || 1);
          data.append('warehouse[0]', '01');

      this.addToCart(data)
        .finally(() => {

          this.isAddCartLoading = false;

        });
    },

    errorModalResponse(error) {
      new Modal(error.response.data.html);
    },

    flashAmountMessage() {
      this.showAmountMessage = true;

      setTimeout(() => {
        this.showAmountMessage = false;
      }, 3000);
    },

    toggleActiveCartIcon(state) {
      const icons = document.querySelectorAll('.cart-svg');

      if(icons.length > 0) {
        icons.forEach(icon => {
          if(icon.classList.contains('active')) {
            return;
          }

          icon.classList.add('active');
        })
      }
    },

    updateCartItem(item, update, callback) {
      let found = this.cartActionData.items.findIndex(el => {
        return el.sku === item.sku && el.warehouse === item.warehouse;
      });

      this.$set(this.cartActionData.items[found], 'isSaving', true);

      let newItem = (isObject(update)) ? Object.assign({}, item, update) : item;

      let data = new FormData;
          data.append('_method', 'patch');
          data.append('sku', newItem.sku);
          data.append('warehouse', newItem.warehouse);
          data.append('quantity', newItem.quantity);
          data.append('note', newItem.note);
          data.append('return', 'alert');

      this.$http.post('/cart/update', data)
        .then(response => {
          this.$set(this.cartActionData.items, found, response.data.item);

          if(typeof callback === 'function') {
            callback();
          }
        })
        .catch(error => {
          new Alert(error.response.data.html);

          this.$set(this.cartActionData.items[found], 'isSaving', false);
        });
    },

  },
}
